import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGate } from './components/AuthGate';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Users } from './pages/Users';
import { UserDetail } from './pages/UserDetail';
import { Trips } from './pages/Trips';
import { TripDetail } from './pages/TripDetail';
import { Feed } from './pages/Feed';
import { EsimPlans } from './pages/EsimPlans';
import { EsimPurchases } from './pages/EsimPurchases';
import { AiConversations } from './pages/AiConversations';
import { AiConversationDetail } from './pages/AiConversationDetail';
import { Settings } from './pages/Settings';
import { Audit } from './pages/Audit';
import { getAccessToken } from './lib/api';

export default function App() {
  // Re-render on token changes (login, logout, 401-clear, refresh).
  const [, force] = useState(0);
  useEffect(() => {
    const handler = () => force((n) => n + 1);
    window.addEventListener('taiya:auth-cleared', handler);
    window.addEventListener('taiya:auth-set', handler);
    return () => {
      window.removeEventListener('taiya:auth-cleared', handler);
      window.removeEventListener('taiya:auth-set', handler);
    };
  }, []);

  const hasToken = !!getAccessToken();

  if (!hasToken) {
    return <AuthGate />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users/:id" element={<UserDetail />} />
        <Route path="/trips" element={<Trips />} />
        <Route path="/trips/:id" element={<TripDetail />} />
        <Route path="/feed" element={<Feed />} />
        <Route path="/esim/plans" element={<EsimPlans />} />
        <Route path="/esim/purchases" element={<EsimPurchases />} />
        <Route path="/ai" element={<AiConversations />} />
        <Route path="/ai/:id" element={<AiConversationDetail />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
